import {createStore} from 'vuex';
import state from './state';
import actions from './actions';
import * as mutations from './mutations';
 
export default createStore({
  state,
  actions,
  mutations
});